export const towns = [
  "Red Bank",
  "Long Branch",
  "Asbury Park",
  // "Ocean Grove",
  "Bradley Beach",
  // "Avon-by-the-sea",
  "Belmar",
  "Spring Lake",
  "Sea Girt",
  "Manasquan",
  "Brielle",
  "Point Pleasant",
];

export const mobileTowns = [
  "Red Bank",
  // "Long Branch",
  "Asbury Park",
  // "Ocean Grove",
  // "Bradley Beach",
  // "Avon-by-the-sea",
  "Belmar",
  // "Spring Lake",
  // "Sea Girt",
  "Manasquan",
  // "Brielle",
  "Point Pleasant",
];

export const events = ["Trivia", "Bingo", "Karaoke", "Yappy Hour"];
export const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
export const truncDays = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
export const times = [
  "All Day",
  "12:00PM",
  "1:00PM",
  "2:00PM",
  "3:00PM",
  "4:00PM",
  "5:00PM",
  "6:00PM",
  "7:00PM",
  "8:00PM",
  "9:00PM",
  "10:00PM",
  "11:00PM",
  "12:00AM",
];
export const sortBy = [
  "Restaurant A to Z",
  "Restaurant Z to A",
  "Town A to Z",
  "Town Z to A",
];
